import styled from 'styled-components';

export const OrderDetailsBox = styled.div.attrs({
  className: 'view-order-details'
})`
  background: #ffffff;
  padding: 0.75rem;
`;

export const ModalBox = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 200px;
`;

export const InputWrapper = styled.div`
  input[type='text'] {
    height: 3rem;
    outline: 0;
    text-overflow: ellipsis;
    border-color: #54595f;
    background-color: #fff;
    padding: 0.5rem 3rem 0.5rem 1rem;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    word-wrap: break-word;
    font-size: 1rem;
    letter-spacing: -0.8px;
    line-height: 1.5;
    font-weight: 400;
    color: #2a2c2e;
    min-height: 3rem;
    max-height: 3rem;
    width: 100%;
    margin: 8px 0;

    :focus {
      box-shadow: rgb(84, 89, 95) 0 0 4px 1px;
      background-color: rgb(255, 255, 255);
      border-color: transparent;
    }
  }
  #basic-typeahead {
    max-height: 200px !important;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
  margin-right: 2rem;
  margin-top: -1.25rem;
`;

export const PaginationContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 25px;
  box-shadow: 1px 1px 5px 0 #d5d5d5;
  height: 48px;
  margin: 8px 0 28px !important;
  padding: 1rem;
`;

export const PageButtons = styled.button`
  background-color: #fff !important;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: default;
  font-weight: 500;

  &: hover {
    border-color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const ActivePage = styled.button`
  background-color: #4b286d !important;
  color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: default;
  font-weight: 500;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtonText = styled.div`
  font-size: 24px;
  margin-top: -7px;
`;

export const NaviagationButtons = styled.button`
  background-color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  color: #4b286d;
  font-weight: 500;
  align-item: center;

  &: hover {
    background-color: #f7f7f8 !important;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const customStyles = `
  overflow: scroll;
  max-height: 80% !important;
  height:83%;
  width: 67%;
  position: fixed;
  margin-left: 17%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;`;

export const DefectSummaryRow = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
`;

export const DefectSummaryFirstCol = styled.div`
  color: #ababab;
  width: 200px;
  padding-right: 20px;
  padding: 10px;
  float: left;
  background: #f7f7f8;
`;

export const DefectSummarySecondCol = styled.div`
  padding-right: 20px;
  padding: 10px;
  float: left;
  word-break: break-word;
`;

export const DefectAttachmentRow = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
  margin-bottom: 1rem !important;
  height: 40px;
  padding: 10px;
`;

export const Filename = styled.div`
  align-items: start;
`;

export const FileDownload = styled.div`
  align-items: end;
`;

export const Container = styled.div`
  margin-bottom: 4rem;
`;

export const SummaryWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const TableBottomBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem 0px;
  padding: 0 0.5rem;
`;

export const DateWrapper = styled.div`
  margin-right: ${props => props.mr}px;
  width: ${props => props.width};
  position: ${props => props.position};
  @media screen and (max-width: 992px) {
    width: 100%;
    margin: 8px 0;
  }
  input {
    background: none;
  }
`;

export const ButtonWrapper = styled.div`
  fieldset > div {
    flex-flow: row nowrap;
  }
`;
